import { SerializedDevice } from "../../../types";

export function includesSerialized(
  devices: MediaDeviceInfo[],
  serializedDevice: SerializedDevice | null,
): boolean {
  if (serializedDevice === null) return false;

  return devices.some(
    (device) =>
      device.deviceId === serializedDevice.deviceId &&
      device.label === serializedDevice.label,
  );
}
